'use es6';

import { fromJS } from 'immutable';
import I18n from 'I18n';
import { AGGREGATION } from 'reporting-data/constants/configTypes';
import { ATTRIBUTION_TOUCH_POINTS } from 'reporting-data/constants/dataTypes/inboundDb';
export const ATTRIBUTION_MODELS = {
  FIRST_INTERACTION: 'hs_first_touch_amount',
  LAST_INTERACTION: 'hs_last_touch_amount',
  FULL_PATH: 'hs_full_path_amount',
  LINEAR: 'hs_linear_amount',
  LINEAR_PRO: 'hs_linear_amount_pro',
  U_SHAPED: 'hs_u_amount',
  W_SHAPED: 'hs_w_amount',
  TIME_DECAY: 'hs_time_decay_amount',
  J_SHAPED: 'hs_j_amount',
  INVERSE_J_SHAPED: 'hs_inverse_j_amount'
};
export const BASE_REPORT_CONFIG = fromJS({
  chartType: 'DATA_WELL',
  config: {
    configType: AGGREGATION,
    dataType: ATTRIBUTION_TOUCH_POINTS,
    dimensions: [],
    limit: 5000
  }
});
export const CONTENT_TYPE_MAP = {
  BLOG_POST: 'BLOG_POST',
  CASE_STUDY: 'CASE_STUDY',
  EMAIL: 'EMAIL',
  LANDING_PAGE: 'LANDING_PAGE',
  SITE_PAGE: 'WEBSITE_PAGE'
};
export const TOUCHPOINT_TYPE_MAP = {
  CTA_CLICK: 'CTA_CLICK'
};
export const LINEAR_AMOUNT_TRANSFORMED_METRIC = 'SUM|hs_linear_amount';
export const DEAL_ID_TRANSFORMED_METRIC = 'DISTINCT_APPROX|hs_deal_id';
export const DEAL_AMOUNT_TRANSFORMED_METRIC = 'MIN|hs_deal_amount';
export const CONTACT_ID_TRANSFORMED_METRIC = 'SUM|hs_contact_id';
export const SUM_OP = 'sum';
export const DISTINCT_OP = 'distinct';
export const DATASET_TYPE = {
  PRIMARY: 'primary',
  SUMMARY: 'summary'
};

// Order based CJA reports utils and consts
//TODO: Move the reports into ReaLM

export const getOrderReportTitle = () => I18n.text('components.orderRevenueReport.email.header');
export const getEmailOrderRevenueReport = (dateRange, email) => ({
  name: getOrderReportTitle(),
  chartType: 'COLUMN',
  journeyQuery: {
    allowAnonymousVisitors: false,
    includeDropoffs: false,
    eventDateInterval: dateRange,
    objectQuery: {
      table: {
        name: 'CONTACT',
        type: 'HUBSPOT_OBJECT',
        objectTypeId: '0-1'
      }
    },
    stages: [{
      orderNumber: 0,
      steps: [{
        name: 'Emails delivered',
        alias: 'e_mta_delivered_email_v2_0_0_137145562',
        query: {
          table: {
            name: 'e_mta_delivered_email_v2',
            type: 'HUBSPOT_EVENT',
            objectTypeId: '4-665536',
            objectObjectTypeIds: []
          },
          filtering: {
            condition: 'AND',
            groups: [{
              id: 137145562,
              condition: 'AND',
              filters: [{
                id: 137145562,
                field: {
                  name: 'hs_email_meta_content_id',
                  table: 'e_mta_delivered_email_v2',
                  source: 'TABLE',
                  type: 'enumeration'
                },
                filter: {
                  filterType: 'PROPERTY',
                  operation: {
                    propertyType: 'enumeration',
                    operator: 'IS_ANY_OF',
                    values: [email.id]
                  },
                  property: 'hs_email_meta_content_id',
                  propertySource: {
                    objectTypeId: '4-665536'
                  }
                },
                isIgnored: false
              }]
            }]
          }
        }
      }]
    }, {
      steps: [{
        name: 'E-commerce Order Updates',
        alias: 'e_ecommerce_order_update_1_0',
        query: {
          table: {
            name: 'e_ecommerce_order_update',
            type: 'HUBSPOT_EVENT',
            objectTypeId: '4-1879129',
            objectObjectTypeIds: [],
            join: [{
              target: {
                name: 'ORDER',
                objectTypeId: '0-123',
                type: 'HUBSPOT_OBJECT',
                join: [{
                  target: {
                    name: 'CONTACT',
                    objectTypeId: '0-1',
                    type: 'HUBSPOT_OBJECT'
                  }
                }]
              }
            }]
          }
        }
      }],
      orderNumber: 1
    }]
  }
});